/** ECharts tooltip HTML — use with `renderMode: 'html'` formatters. */

export function dashboardChartTooltipHeading(text, className = '') {
  const extra = className ? ` ${className}` : '';
  return `<div class="dashboard-chart-tooltip-heading text-offblack${extra}">${text}</div>`;
}

export function dashboardChartTooltipSeriesRow(param, seriesNameFallback = '') {
  if (!param) return '';
  const val =
    param.value !== undefined && param.value !== null ? Number(param.value).toLocaleString() : '';
  const label = param.seriesName || seriesNameFallback;
  const dot = `<span style="display:inline-block;margin-right:6px;border-radius:50%;width:10px;height:10px;background-color:${param.color};"></span>`;
  return `<div>${dot}<span class="dashboard-chart-tooltip-label text-offblack">${label}</span> <span class="dashboard-chart-tooltip-value text-offblack">${val}</span></div>`;
}

export function dashboardChartTooltipAxisFormatter(params, seriesNameFallback = '') {
  if (!params || !params.length) return '';
  const axisLabel = params[0].axisValueLabel || params[0].name || '';
  let html = dashboardChartTooltipHeading(axisLabel, 'text-left');
  params.forEach((param) => {
    html += dashboardChartTooltipSeriesRow(param, seriesNameFallback);
  });
  return html;
}

export function dashboardChartTooltipPieFormatter(params, { title, label, value }) {
  if (!params || !params.data) return '';
  const dot = `<span style="display:inline-block;margin-right:6px;border-radius:50%;width:10px;height:10px;background-color:${params.color};"></span>`;
  let html = dashboardChartTooltipHeading(title);
  html += `<div>${dot}<span class="dashboard-chart-tooltip-label text-offblack">${label}</span> <span class="dashboard-chart-tooltip-value text-offblack">${value}</span></div>`;
  return html;
}
